(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-own-bundle"] && !Shopify.designMode) return;
  try {
    
  class RRBundleBuilder {
    constructor(section) {
      this.section = section;
      this.data = JSON.parse(
        section.querySelector('[data-bundle-products]').textContent
      );

      this.groups = this.data.groups;
      this.selection = {};

      this.discountType = section.dataset.discountType;
      this.discountValue = Number(section.dataset.discountValue || 0);

      this.addButton = section.querySelector('[data-add-bundle]');
      this.status = section.querySelector('[data-bundle-status]');

      this.bindEvents();
      this.initialiseGroups();
      this.updateSummary();
    }

    bindEvents() {
      this.section.addEventListener('click', (event) => {
        const productButton = event.target.closest('[data-product-index]');
        const variantButton = event.target.closest('[data-variant-id]');

        if (productButton) {
          this.selectProduct(
            productButton.dataset.group,
            Number(productButton.dataset.productIndex)
          );
        }

        if (variantButton && !variantButton.disabled) {
          this.selectVariant(
            variantButton.dataset.group,
            Number(variantButton.dataset.variantId)
          );
        }
      });

      this.addButton.addEventListener('click', () => this.addBundleToCart());
    }

    initialiseGroups() {
      Object.entries(this.groups).forEach(([groupKey, products]) => {
        if (!products.length) return;

        const initialProductIndex = products.findIndex((product) =>
          product.variants.some((variant) => variant.available)
        );

        this.selectProduct(
          groupKey,
          initialProductIndex >= 0 ? initialProductIndex : 0
        );
      });
    }

    selectProduct(groupKey, productIndex) {
      const product = this.groups[groupKey][productIndex];
      if (!product) return;

      const availableVariant =
        product.variants.find((variant) => variant.available) ||
        product.variants[0];

      this.selection[groupKey] = {
        productIndex,
        product,
        variant: availableVariant
      };

      this.renderGroup(groupKey);
      this.updateSummary();
    }

    selectVariant(groupKey, variantId) {
      const selected = this.selection[groupKey];
      if (!selected) return;

      const variant = selected.product.variants.find(
        (item) => item.id === variantId
      );

      if (!variant || !variant.available) return;

      selected.variant = variant;

      this.renderGroup(groupKey);
      this.updateSummary();
    }

    renderGroup(groupKey) {
      const groupElement = this.section.querySelector(
        `[data-bundle-group="${groupKey}"]`
      );

      const selected = this.selection[groupKey];
      if (!groupElement || !selected) return;

      const image =
        selected.variant.featuredImage || selected.product.featuredImage;

      const imageElement = groupElement.querySelector('[data-group-image]');

if (imageElement && image?.src) {
  imageElement.removeAttribute('srcset');
  imageElement.removeAttribute('sizes');

  imageElement.src = image.src;
  imageElement.alt = image.alt || selected.product.title;
}

      groupElement.querySelector('[data-selected-product-name]').textContent =
        selected.product.title;

      groupElement
        .querySelectorAll('[data-product-index]')
        .forEach((button) => {
          button.setAttribute(
            'aria-pressed',
            Number(button.dataset.productIndex) === selected.productIndex
              ? 'true'
              : 'false'
          );
        });

      const variantContainer = groupElement.querySelector(
        '[data-variant-options]'
      );

      variantContainer.innerHTML = '';

      selected.product.variants.forEach((variant) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'rr-variant-option';
        button.dataset.group = groupKey;
        button.dataset.variantId = variant.id;
        button.textContent =
          variant.title === 'Default Title' ? 'One size' : variant.title;
        button.disabled = !variant.available;

        button.setAttribute(
          'aria-pressed',
          selected.variant.id === variant.id ? 'true' : 'false'
        );

        if (!variant.available) {
          button.setAttribute('aria-label', `${variant.title} sold out`);
        }

        variantContainer.appendChild(button);
      });
    }

    updateSummary() {
      let originalTotal = 0;
      let completedGroups = 0;

      Object.entries(this.groups).forEach(([groupKey]) => {
        const selected = this.selection[groupKey];
        const summaryLine = this.section.querySelector(
          `[data-summary-group="${groupKey}"] .rr-summary-line__selection`
        );

        if (selected?.variant?.available) {
          completedGroups += 1;
          originalTotal += selected.variant.price;

          const variantText =
            selected.variant.title === 'Default Title'
              ? ''
              : ` — ${selected.variant.title}`;

          summaryLine.textContent =
            `${selected.product.title}${variantText}`;
        } else {
          summaryLine.textContent = 'Not selected';
        }
      });

      const requiredGroups = Object.keys(this.groups).length;
      const isComplete = completedGroups === requiredGroups;

      const saving = isComplete
        ? this.calculateSaving(originalTotal)
        : 0;

      const bundleTotal = Math.max(originalTotal - saving, 0);

      this.section.querySelector('[data-original-total]').textContent =
        this.formatMoney(originalTotal);

      this.section.querySelector('[data-saving-total]').textContent =
        this.formatMoney(saving);

      this.section.querySelector('[data-bundle-total]').textContent =
        this.formatMoney(bundleTotal);

      this.addButton.disabled = !isComplete;

      this.section.querySelector('[data-bundle-message]').textContent =
        isComplete
          ? 'Your walk set is ready.'
          : `Choose ${requiredGroups - completedGroups} more item${
              requiredGroups - completedGroups === 1 ? '' : 's'
            } to complete your set.`;
    }

    calculateSaving(total) {
      if (this.discountType === 'percentage') {
        return Math.round(total * (this.discountValue / 100));
      }

      if (this.discountType === 'fixed') {
        return Math.round(this.discountValue * 100);
      }

      return 0;
    }

    formatMoney(cents) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: this.data.currency || 'GBP'
      }).format(cents / 100);
    }

    async addBundleToCart() {
      const items = Object.entries(this.selection).map(
        ([groupKey, selected]) => ({
          id: selected.variant.id,
          quantity: 1,
          properties: {
            '_Bundle': 'Build Your Own Walk Set',
            '_Bundle component': groupKey
          }
        })
      );

      if (items.length !== Object.keys(this.groups).length) return;

      this.addButton.disabled = true;
      this.addButton.textContent = 'Adding your set…';
      this.status.textContent = '';

      try {
        const root =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description || 'Your set could not be added.'
          );
        }

        this.status.textContent = 'Your complete walk set has been added.';

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { source: 'rr-bundle-builder' }
          })
        );

        window.location.href = `${root}cart`;
      } catch (error) {
        console.error(error);
        this.status.textContent =
          error.message || 'Something went wrong. Please try again.';
        this.addButton.disabled = false;
        this.addButton.textContent = 'Add complete set to bag';
      }
    }
  }

  document
    .querySelectorAll('[id^="BundleBuilder-"]')
    .forEach((section) => {
      if (!section.dataset.initialised) {
        new RRBundleBuilder(section);
        section.dataset.initialised = 'true';
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
